<template>
  <div class="download-android">
    <div class="wrap">
      <LayoutHeader />

      <footer>
        <img
          v-if="language === 'zh'"
          src="../assets/images/android-zh.png"
          alt
        />
        <!-- platformQuery === 'android' && -->
        <img
          v-if="language === 'en'"
          src="../assets/images/android-en.png"
          alt
        />
      </footer>

      <main>
        <h3 class="header-title">{{ $t("views.header.title") }}</h3>
        <h4 class="header-text">{{ $t("views.header.text") }}</h4>

        <!-- v-if="platformQuery === 'android' || platformQuery === 'pc'" -->
        <!-- :style="{ marginTop: language === 'en' ? '1rem' : '' }" -->
        <div class="download-wrap">
          <div class="download-btn">
            <a class="download-btn-a" :href="androidHref">
              <i class="android"></i>
              {{ $t("views.download") }}
            </a>
            <!-- <div class="version">{{$t('views.version')}}: v{{versionInfo.android}}</div> -->
          </div>

          <div class="download-btn">
            <a
              class="download-btn-a"
              href="https://play.google.com/store/apps/details?id=vip.mytokenpocket"
            >
              <i class="google"></i>
              <div class="right">
                <span>{{ $t("views.getItOn") }}</span>
                <span>Google Play</span>
              </div>
            </a>
          </div>
        </div>

        <!-- <div
          class="download-wrap"
          :style="{marginTop: language === 'en' ? '.5rem' : ''}"
          v-if="platformQuery === 'ios' || platformQuery === 'pc'"
        >
          <div class="download-btn">
            <a class="download-btn-a" @click="goAppStore(3)">
              {{$t('views.beta')}}
              <i class="recommend">{{$t('views.recommend')}}</i>
            </a>
          </div>

          <div class="download-btn">
            <a
              class="download-btn-a"
              href="itms-services://?action=download-manifest&url=https://dapp.mytokenpocket.vip/app.plist"
            >
              <i class="ios"></i>
              {{$t('views.enterpriseEdition')}}</a>
          </div>
        </div>-->

        <!-- <div
          class="app-course"
          v-if="(platformQuery === 'ios' && language === 'zh') || (platformQuery === 'pc' && language === 'zh')"
        >
          <h5>
            什么是公测版和企业版？
            <i class="id">免海外ID</i>
          </h5>
          <p >两者均可体验最新的钱包功能，但稳定性不如正式版（App Store版本），下载公测版和企业版的用户务必做好私钥备份措施，以免造成损失。</p>

          <h5 style="margin-top:.4rem;">无法更新或下载出错？</h5>
          <p >
            常见下载问题，可点此
            <span @click="goLink('help')">寻求帮助</span>
          </p>
        </div>-->
      </main>

      <Description
        :versionData="versionData"
        @openModal="openModal"
        :androidVersion="androidVersion"
        :googlePlayVersion="googlePlayVersion"
      />
    </div>

    <!-- 微信浏览器 -->
    <div class="web-wechat" v-if="platform.isWeChat">
      <img src="../assets/images/wechat-bg.png" alt />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import axios from 'axios'
import LayoutHeader from "../components/LayoutHeader";
import platform from "../assets/js/platform";
import Description from "../components/Description.vue";
export default {
  name: "downloadAndroid",
  components: {
    LayoutHeader,
    Description,
  },
  data() {
    return {
      platform,
      platformQuery: "pc",
      versionInfo: {
        ios_e: "", // ios企业版
        ios_a: "", // ios appstore版本
        android: "", // android版本
        pc: "", // pc版本
      },
      versionData: {},
      androidVersion: {},
      googlePlayVersion: {},
      androidHref:
        "https://dapp.tptool.pro/apk/TokenPocket-pro.apk?t=" +
        new Date().getTime(),
    };
  },

  computed: {
    ...mapGetters(["language"]),
    isWeChat() {
      return this.platform === "weChat";
    },
  },

  created() {
    this.getVersion();
  },

  methods: {
    async getVersion() {
      try {
        const response = await fetch(
          "https://preserver.mytokenpocket.vip/v1/version/hash"
          // "https://testserver.mytokenpocket.vip/v1/version/hash"
        );
        const res = await response.json();
        if (res.result === 0) {
          if (Array.isArray(res.data)) {
            this.moreVersion(res.data);
          } else {
            this.versionData = res.data;
            window.localStorage.setItem(
              "versionData",
              JSON.stringify(res.data)
            );
          }
        }
      } catch (error) {
        const data = window.localStorage.getItem("versionData");
        if (Array.isArray(data)) {
          this.moreVersion(data);
        } else {
          this.versionData = JSON.parse(
            window.localStorage.getItem("versionData")
          );
        }
      }
    },
    moreVersion(arr) {
      // 返回的是多个版本，android 和 google play
      arr.forEach((item) => {
        if (item.channel == "std") {
          this.androidVersion = item;
        }
        if (item.channel == "gp") {
          this.googlePlayVersion = item;
        }
      });
      // console.log("androidVersion", this.androidVersion);
      // console.log("googlePlayVersion", this.googlePlayVersion);
      window.localStorage.setItem("versionData", JSON.stringify(arr));
    },
    openModal() {
      this.$modal.show("version-panel");
    },
    goLink(type) {
      const url = {
        appID:
          "https://www.yuque.com/docs/share/ad8a0309-43de-4743-9547-e8b3eeea8c72?#",
        help: "https://help.mytokenpocket.vip/hc/zh-cn/articles/360022090951-%E9%92%B1%E5%8C%85%E4%B8%8B%E8%BD%BD%E5%B8%B8%E8%A7%81%E9%97%AE%E9%A2%98",
      };
      window.open(url[type]);
    },

    goAppStore(type) {
      switch (type) {
        case 1:
          let url =
            this.language === "zh"
              ? "https://apps.apple.com/hk/app/tp-global-wallet/id6444625622"
              : "https://apps.apple.com/hk/app/tp-global-wallet/id6444625622";
          window.open(url);
          break;
        case 2:
          window.open(
            "itms-services://?action=download-manifest&url=https://dapp.tptool.pro/app.plist"
          );
          break;
        case 3:
          window.open("https://testflight.apple.com/join/4yN9AyXA");
      }
    },

    goGooglePlay() {
      window.open(
        "https://play.google.com/store/apps/details?id=vip.mytokenpocket"
      );
    },

    goAndroidDownload() {
      window.open(this.androidHref);
    },
  },
  mounted() {},
};
// <style lang="scss" scoped>
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$bg-1: #2980fe;
$bg-2: #3a3b3d;
$ft-20: 0.2rem;
$ft-22: 0.22rem;
$ft-24: 0.24rem;
$ft-26: 0.26rem;
$ft-30: 0.3rem;

.ft-14 {
  font-size: 14px;
}

.step {
  padding: 15px;
  img {
    width: 100%;
  }
}

body {
  font-family: PingFang-SC-Bold;
}

main {
  margin-top: 0.44rem;
  padding: 0 0.56rem;
  padding: 0 0.32rem;

  .header-title {
    margin-bottom: 0.16rem;
    font-size: 0.42rem;
    font-family: PingFangSC, PingFangSC-Semibold;
    font-weight: 700;
    text-align: left;
    color: #333333;
    line-height: 0.59rem;
    letter-spacing: -0.57px;
  }

  .header-text {
    font-size: 0.28rem;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 0.4rem;
    letter-spacing: -0.38px;
  }

  .app-store-btn {
    background: $bg-1;
    font-size: 0.3rem;
    color: #fff;
    height: 1.08rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 0.54rem;
    opacity: 0.3;
    pointer-events: none;
    cursor: default;
    i {
      display: inline-block;
      width: 0.56rem;
      height: 0.56rem;
      background: url(../assets/images/app-store.png) no-repeat center 100% /
        contain;
      vertical-align: middle;
      margin-right: 0.4rem;
    }
  }
}

.recommend {
  font-style: normal;
  display: flex;
  background: #f2f2f2;
  color: #3a3b3d;
  width: 0.88rem;
  height: 0.36rem;
  align-items: center;
  justify-content: center;
  /*line-height: 0.38rem;*/
  border-radius: 0.18rem;
  font-size: $ft-20;
  margin-left: 0.1rem;
}

.download-wrap {
  margin: 0.44rem 0 0.5rem;
  display: flex;
}

.download-btn {
  flex: 1;
  &:nth-of-type(2n) {
    text-align: right;
  }
  &:nth-child(2) {
    margin-left: 0.3rem;
  }
  .download-btn-a {
    color: rgba(255, 255, 255, 1);
    display: flex;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    height: 0.98rem;
    background: #101010;
    border-radius: 0.12rem;
    box-shadow: 0 0.08rem 0.73rem 0 rgba(0, 77, 255, 0.1);
    .right {
      display: flex;
      flex-direction: column;
      span {
        text-align: left;
      }
      :nth-child(1) {
        font-size: 0.22rem;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #ffffff;
        line-height: 0.3rem;
      }
      :nth-child(2) {
        font-size: 0.32rem;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        color: #ffffff;
        line-height: 0.45rem;
      }
    }
  }
}

.android {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
  vertical-align: sub;
  background: url(../assets/images/android.png) no-repeat center 100% / contain;
}

.google {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  margin-right: 0.2rem;
  vertical-align: sub;
  background: url(../assets/images/google-play.png) no-repeat center 100% /
    contain;
}

.ios {
  /*position: relative;*/
  /*<!--top: -2px;-->*/
  display: inline-block;
  width: 0.3rem;
  height: 0.3rem;
  margin-right: 0.1rem;
  vertical-align: sub;
  background: url(../assets/images/apple.png) no-repeat center 100% / contain;
}

.version {
  font-size: 0.24rem;
  margin: 0.2rem 0;
}

.app-course {
  background: #f5f6f7;
  border-radius: 0.16rem;
  padding: 0.32rem 0.56rem;
  padding: 0.32rem;
  margin: 0.4rem 0 1rem;
  h5 {
    color: #3a3b3d;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
    font-size: $ft-26;
    margin-bottom: 0.1rem;
  }
  p {
    font-size: $ft-22;
    font-family: PingFang-SC-Regular;
    line-height: 1.5;
    color: #9ea0a5;
    span {
      color: #2980fe;
    }
  }

  .id {
    display: inline-block;
    background: #fde0b0;
    color: #b07616;
    font-size: $ft-22;
    width: 1.4rem;
    // height: .4rem;
    // line-height: .4rem;
    border-radius: 0.2rem;
    font-style: normal;
    text-align: center;
    padding: 0.05rem;
  }
}

footer {
  text-align: center;
  img {
    width: 100%;
  }
}

.web-wechat {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  img {
    display: block;
    width: 100%;
    height: 100%;
  }
}
</style>
